import type {DAL} from '@wix/document-manager-core'
import type {CustomComponentInfo, Pointers} from '@wix/document-services-types'

export const getOverrideId = (dal: DAL, pointers: Pointers, appDefId: string): string | undefined => {
    if (pointers.documentServicesModel?.getCustomComponentInfo) {
        const customComponentInfo = dal.get(pointers.documentServicesModel.getCustomComponentInfo()) as
            | CustomComponentInfo
            | undefined
        if (customComponentInfo?.appId === appDefId) {
            return customComponentInfo.componentsOverrideId
        }
    }
    return dal.get(pointers.rendererModel.getClientSpecMapEntryByAppDefId(appDefId))?.appFields?.overrideId
}
